"use strict";

PF.Model.File = class ModelFile extends PF.Model
	{
	static get options()
		{
		return {
			saveUrl: '/file/save',
			deleteUrl: '/file/delete',
			previewTypes: [],
			isUpload: true,
		};
		}

	byInfo(info)
		{
		this.options.isUpload = false;
		this.setData('name', info.name);
		this.setData('size', info.size);
		this.setData('type', info.type);

		let fr = new FileReader();
		fr.onload = (event) => {
			if (event.currentTarget !== undefined)
				{
				this.options.rawData = event.currentTarget.result;
				this.options.hasData = true;
				this.trigger('file-readed');
				}
		};
		fr.readAsArrayBuffer(info);
		}

	saveFile(onSuccess = () => {
	})
		{
		let url = app.makeUrl(this.options.saveUrl);
		var formData = new FormData();

		formData.append("descr", JSON.stringify(this.toJSON()));
		formData.append("previewTypes", JSON.stringify(this.options.previewTypes));
		var blob = new Blob([this.options.rawData], {type: this.get('type')});
		formData.append("file", blob);

		var request = new XMLHttpRequest();
		request.open("POST", url);
		// request.setRequestHeader('Content-Type', 'multipart/form-data')
		request.onload = (event) => {
			console.log(event.target.response);
			let response = JSON.parse(event.target.response);
			this.populateData(response.file);
			this.options.isUpload = true;
			onSuccess(response);
		};
		request.send(formData);
		}

	deleteFile()
		{

		}

	get sizeHr()
		{
		return PF.Model.File.sizeHr(this.size);
		}

	static sizeHr(bytes, byte = true)
		{
		var thresh = byte ? 1000 : 1024;
		if (Math.abs(bytes) < thresh)
			{
			return bytes + ' Б';
			}
		var units = byte
			? ['КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ']
			: ['KiB', 'MiB', 'GiB', 'TiB',];
		var u = -1;
		do
			{
			bytes /= thresh;
			++u;
			}
		while (Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(1) + ' ' + units[u];
		}

	static download(url)
		{
		var link = document.createElement('a');
		link.href = url;
		if (document.createEvent)
			{
			var e = document.createEvent('MouseEvents');
			e.initEvent('click', true, true);
			link.dispatchEvent(e);
			return true;
			}
		window.open(url, '_self');
		}

	};




